import Vue from 'vue'
import Router from 'vue-router'
import routers from './router'
import vueg from 'vueg'
import {oAuth,setUser} from '@/assets/js/utils/auth'
import store from '@/store'
import querystring from 'vux/src/tools/querystring/index.js'


Vue.use(Router)

var router = new Router({
mode: 'history',
routes: routers
})
const options={
duration: '0.3',              //转场动画时长，默认为0.3，单位秒
firstEntryDisable: false,     //值为true时禁用首次进入应用时的渐现动画，默认为false
firstEntryDuration: '.6',     //首次进入应用时的渐现动画时长，默认为.6
forwardAnim: 'fadeInRight',   //前进动画，默认为fadeInRight
backAnim: 'fadeInLeft',       //后退动画，默认为fedeInLeft
sameDepthDisable: false,      //url深度相同时禁用动画，默认为false
tabs: [{
name:'home'
},{
name:'my'
}],                       //默认为[]，name对应路由的name,以实现类似app中点击tab页面水平转场效果，如tab[1]到tab[0]，会使用backAnim动画，tab[1]到tab[2]，会使用forwardAnim动画
tabsDisable: false,           //值为true时，tabs间的转场没有动画，默认为false
disable: false,               //禁用转场动画，默认为false，嵌套路由默认为true
}
Vue.use(vueg, router,options)
router.beforeEach((to, from, next) => {
document.title = to.name 
if(to.meta.oAuth === 'false'){
next()
}
else{
if (store.getters.userInfo.name.length > 0) {
next()
}
else{
let session = sessionStorage.getItem('wx-user')
if (session) {
setUser(session)
next()
}else{
Vue.$vux.loading.show({
text: ''
})
let query= querystring.parse(window.location.search)
if(query.code || query.userid){
oAuth(query).then(response => {
if(response.data.result){
let str = JSON.stringify(response.data.data)
setUser(str)
next()
}
Vue.$vux.loading.hide()
})
}
else{
if(process.env.NODE_ENV == 'development'){
window.location.href = window.location.href + "?userid=yuanguojian"
}
else{
let url = encodeURIComponent(process.env.BASE_URL + to.fullPath) 
window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wwa2544264a2060d1f&redirect_uri=' + url + '&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect'
}
}
}
}
}
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js